import { Component, ChangeDetectorRef } from '@angular/core';
import { AppComponent } from "../../../app.component";
import {SubmissionHistoryService} from "../../../shared/services/submission-history.service";
import {Subscription} from "rxjs";
import {SubmissionSearchUserInfoObject} from "../search-object";

@Component({
  selector: 'footer-component',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent  {
    currentYear = 0;

    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();
    private        userInfoSubscription: Subscription;

    constructor(private ref:ChangeDetectorRef, public appComponent: AppComponent, private readonly submissionHistoryService : SubmissionHistoryService) {
        this.currentYear = (new Date()).getFullYear();
    }

    ngOnInit() {
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => {this.userInfo = message});
    }
}
